import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";

import store from "features/store";
import { addDataLayer, getItemUrl } from "shared/utils/utils";
import { image_thumbnail, loaderIcon } from "shared/images/images";
import { isAuthorized } from "shared/settings/auth";
import { ItemsService } from "shared/services";
import { eye, thumbsDownIcon, thumbsUpIcon } from "shared/assets/icons";
import { CountdownHoc, COUNTDOWN_TYPE } from "./CountdownHoc";
import { Link } from "react-router-dom";

import "./itemcard.scss";

function ItemCard({ items, currentBids, watch, bidnow, recallWatchList, type, extra }) {

    const dispatch = useDispatch();

    const bidItemIds = useSelector(state => state.sseItemIds);

    const [bidLoading, setBidLoading] = useState(false);
    const [currentBid, setCurrentBid] = useState(0);
    const [proxyPrice, setProxyPrice] = useState(items.maxproxyprice || 0);
    const [biddingStatus, setBiddingStatus] = useState(extra?.biddingstatus || '');
    const [itemCloseTime, setItemCloseTime] = useState(items.itemclosetime);
    const [isItemClosed, setIsItemClosed] = useState(items.itemstatus !== 'Ready' ? true : false);

    useEffect(() => {
        // TODO check for single item id.
        if ( Array.isArray(bidItemIds) && bidItemIds.length > 0 && bidItemIds.includes(items.id) ) {
            setBidLoading(true);
            const data = {
                "itemIds": [items.id]
            };
            ItemsService.getCurrentBidValue({ data }).then(response => {
                if ( response.data.data.length > 0 ) {
                    const data = response.data.data[0];
                    setCurrentBid(data.bidprice);
                    setItemCloseTime(data.itemclosetime);
                }
                setBidLoading(false);
            }).catch(error => {
                setBidLoading(false);
            });

            if ( type === 'Bidding' ) {
                let payload = {
                    "field": ["itemid", "biddingstatus", "maxproxyprice"],
                    "filter": [
                        { field: "itemid", value: [bidItemIds], op: "IN", join: "AND" }
                    ],
                    "page": { "size": 1 }
                };
                ItemsService.getBidding(payload).then(async (response) => {
                    if (response?.data?.data?.length > 0) {
                        setBiddingStatus(response.data.data[0].biddingstatus);
                        setProxyPrice(response.data.data[0].maxproxyprice);
                    }
                }).catch((error) => {});
            }
        }
    }, [bidItemIds]);

    useEffect(() => {
        if ( Array.isArray(currentBids) && currentBids.length > 0 ) {
            findAndSetCurrentBid();

            dispatch({type: 'BIDS', payload: []});
        }
    }, [currentBids]);

    const findAndSetCurrentBid = () => {
        const itemId = items.id ? items.id : items.itemid;
        const itemValue = currentBids.filter(x => x.itemid === itemId);
        setCurrentBid(itemValue.length > 0 ? isNaN(itemValue[0].bidprice) ? 0 : itemValue[0].bidprice : 0);
    }

    const watching = (items) => {
        const itemId = items.id ? items.id : items.itemid;
        return watch.filter(x => x.itemid === itemId).length > 0;
    };
    
    const addOrRemoveWatch = () => {
        const itemId = items.id ? items.id : items.itemid;
        if (isAuthorized()) {
            let index = watch.findIndex(x => x.itemid === itemId)
            if (!(index >= 0)) {
                const addData = {
                    "data": [
                        {
                            "itemid": itemId
                        }
                    ]
                }
                ItemsService.addToWatch(addData).then(
                    response => {
                        recallWatchList()
                    }
                ).catch(error => {
                });
            } else {
                const removeData = {
                    "data": {
                        "itemIds": [itemId]
                    }
                };
                ItemsService.removeFromWatch(removeData).then(
                    response => {
                        recallWatchList()
                    }
                ).catch(error => {
                });
            }
        } else {
            store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
        }
    }
  
    const handleNavigate = () =>{
        let dataLayerData = {
            'event': 'bid_now',
            'title': items.title
        }
        addDataLayer(dataLayerData);
        bidnow()
    }

    return (
        <div className="itemcard" key={items.id || items.itemid}>
            <div className="borderview">
                {
                    type == "Bidding" && 
                    <div className="p-2">
                        {biddingStatus == "Not Won" && <div className="d-flex notwinicon align-items-center">{thumbsDownIcon} Not Winning</div>}
                        {biddingStatus == "Won" && <div className="d-flex winicon align-items-center">{thumbsUpIcon} Winning</div>}
                    </div>
                }
                {
                    type == "WatchList" && 
                    <div className="p-2">
                        <Form.Check
                            type="checkbox"
                            checked={extra?.selectedList.includes(items?.id)}
                            aria-label=''
                            onChange={() => { extra?.onselect && extra?.onselect() }}
                        />
                    </div>
                }
                <div>
                    <Link
                        className="image-container d-flex flex-column align-items-center justify-content-center clickable"
                        to={`/estate-sale/${items.saleid}/item/${items.id ? items.id : items.itemid}/${items.itemseourl}`}
                        onClick={(e) => {
                            // Allow default behavior for Ctrl/Cmd/Middle click
                            if (e.ctrlKey || e.metaKey || e.button === 1) return;
                            e.preventDefault();
                            handleNavigate();
                        }}>
                        <img alt={`item-image id:- ${items?.id}`} src={items.thumbnailurl ? items.thumbnailurl : items.displayimageurl ? items.displayimageurl : image_thumbnail} className="items-image" onError={(event) => {
                            event.target.src = image_thumbnail;
                        }} />
                    </Link>
                    <div className="m-3">
                        <div className="d-flex align-items-center gap3 ">
                            <div className={`itemtypename ${items.itemtypeid == 1 ? "directBuy":items.itemtypeid == 3?"onsite":"auction"} `}> {items?.itemtypename?.toUpperCase()}</div>
                            <div className={`deliverytype ${items.isshippable ?"ship":"pick"}` }> {items.isshippable ? "SHIPPABLE" : "PICK UP ONLY"}</div>
                        </div>
                        <div className="my-2">
                            <div className='itemcard-head '>{items.title}</div>
                        </div>
                        <div className={`d-flex-resp ${type == "Bidding" ? "align-items-start" : "align-items-center"} justify-content-between `}>
                            {
                                type == "Bidding" ?
                                <>
                                    {
                                        bidLoading ?
                                        <img className="loader-gif" src={loaderIcon} alt="loader-icon"></img> :
                                        <div className="d-flex flex-column gap-1">
                                            <div className="bid-val">Highest Bid: ${parseFloat(currentBid).toFixed(2)}</div>
                                            <div className="bid-val">Your Proxy bid: ${parseFloat(proxyPrice).toFixed(2)} </div>
                                        </div>
                                    }
                                </> :
                                <>
                                    {
                                        bidLoading ?
                                        <img className="loader-gif" src={loaderIcon} alt="loader-icon"></img> :
                                        <div className="bid-val">Current bid: ${parseFloat(currentBid).toFixed(2)}</div>
                                    }
                                </>
                            }
                            {
                                items.itemstatus === 'Ready' ?
                                    <CountdownHoc type={COUNTDOWN_TYPE.ITEM} targetTime={itemCloseTime} itemId={items.id} displayAsRow={false} onDoneCallback={() => setIsItemClosed(true)} /> :
                                    <div className='text-danger'>
                                        {
                                            items.itemstatus === "Sold" || items.itemstatus === "Not Sold" ? 'Item closed' : 'Item not available'
                                        }
                                    </div>
                            }
                        </div>
                        {
                            !isItemClosed && 
                            <div className="bottombutton ">
                                <Button className={`${watching(items) ? 'btn-secondary' : 'btn-white '} rounded`}
                                    onClick={() => { addOrRemoveWatch() }}
                                >
                                {eye}
                                </Button>
                                <Button
                                    className=' bidnowbtn'
                                    onClick={() => { handleNavigate() }}
                                    disabled={items.itemclosetime == null}
                                > {items.itemtypeid && items.itemtypeid === 1 ? 'Buy Now' : type == "Bidding" ? 'Change Bid' : 'Bid Now'}</Button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )

}
export default ItemCard;